<h1 mat-dialog-title>Manually Add</h1>
<div mat-dialog-content>

  <form #f="ngForm">
    <mat-form-field>
      <mat-label>Manufacturer </mat-label>
      <input matInput name="manufacturer" [(ngModel)]="data.manufacturer" required>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Model </mat-label>
      <input matInput name="model" [(ngModel)]="data.model" required>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Serial Number</mat-label>
      <input matInput name="serial_number" [(ngModel)]="data.serial_number" required>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Serial Number New</mat-label>
      <input matInput name="serial_number_new" [(ngModel)]="data.serial_number_new">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Results</mat-label>
      <mat-select name="results" [(ngModel)]="data.results" required>
        <mat-option value="Passed">Passed</mat-option>
        <mat-option value="Partial">Partial</mat-option>
        <mat-option value="Failed">Failed</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>PO</mat-label>
      <input matInput name="po" [(ngModel)]="data.po" required>
    </mat-form-field>
  </form>


</div>
<div mat-dialog-actions>
  <button class="btn btn-success" (click)="onNoClick()" [disabled]="!f.valid || saving">
    <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i> &nbsp; Save
  </button>
  &nbsp;&nbsp;
  <button class="btn btn-default" [mat-dialog-close]="null" cdkFocusInitial>Cancel</button>
</div>
